<!-- 快速生成费用 -->
 <template>
    <div>
        <el-dialog v-dialogDrag title="快速生成费用" width="65%"  :visible.sync="quickFeesShow" :close-on-click-modal="false"
            :before-close="handleClose">
            <el-form :rules="rules" ref="quickFees" :model="quickFees" label-width="80px" size="mini" :inline="true" class="demo-form-inline"> 
                <el-form-item label="往来单位" prop="companyName">
                    <el-select v-model="quickFees.companyName" filterable  placeholder="请选择往来单位">
                        <el-option v-for="item in companyNameList" :key="item.name" :label="item.name" :value="item.name"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="费用名称" prop="feeName">
                    <el-select v-model="quickFees.feeName" filterable  placeholder="请选择费用名称">
                        <el-option v-for="item in feeNameList" :key="item.feeName" :label="item.feeName" :value="item.feeName"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="币制" prop="currency">
                    <el-select v-model="quickFees.currency" filterable  placeholder="请选择币制" @change="exitTaxRate">
                        <el-option v-for="item in DicList" :key="item.value" :label="item.value" :value="item.value" > </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="汇率" prop="exchangeRate">
                    <el-input  :disabled="quickFees.currency === 'VND' ? true:false"  v-model="quickFees.exchangeRate" placeholder="请输入汇率"  clearable></el-input>
                </el-form-item>
                <el-form-item label="单价">
                    <el-input v-model="unitPriceValue" placeholder="请输入单价" @input="priceFilling" @blur="handleBlur" @focus="handleFocus" onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')"  clearable></el-input>
                </el-form-item>
                <el-form-item label="税率" prop="tax">
                    <!-- 税率/100 -->
                    <el-input v-model="quickFees.tax" placeholder="请输入税率"  onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')"  clearable></el-input>
                </el-form-item>
                <el-form-item label="合计">
                    <el-input v-model="totalCost" :disabled="true" ></el-input>
                </el-form-item>
                <el-form-item label="是否含税" prop="withTax">
                    <el-radio v-model="quickFees.withTax" :label="false">不含税</el-radio>
                    <el-radio v-model="quickFees.withTax" :label="true">含税</el-radio>
                </el-form-item>
                
                <!-- <el-form-item label=" ">
                    <el-button type="primary" @click="priceFilling">价格填充</el-button>
                </el-form-item> -->
            </el-form>
            <!-- 箱型箱号 -->
             <el-table border :data="boxTable" style="width: 100%" size="mini" max-height="400px"  @selection-change="handleSelectBox"
             :header-cell-style="{'text-align':'center'}" >
                <el-table-column type="selection"  width="55"  align="center"> </el-table-column>
                <el-table-column prop="containerId" label="集装箱号" align="center"> </el-table-column>
                <el-table-column prop="containerType" label="箱型" align="center"> </el-table-column>
                <el-table-column prop="unitPrice" label="单价" align="center"> 
                    <template slot-scope="scope">
                        <el-input size="mini" v-model="scope.row.unitPrice" @blur="handleBlurTable(scope.row)" @input="changeTotal" @focus="handleFocusTable(scope.row)" placeholder="请输入单价"  onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')" clearable></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="deliveryDate" label="送货日期" align="center"> </el-table-column>
                <el-table-column prop="truckNo" label="车号" align="center"> </el-table-column>
                <el-table-column prop="truckCompany" label="运输公司" align="center"> </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="quickFeesSave('quickFees')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import req from '@/utils/index.js'
import url1 from '@/config/url1.js'
import url2 from '@/config/url2.js'

export default {
    name: '',
    props: {
        quickFeesShow: {
            type: Boolean,
            default: false
        },
        quickFeesType:{
            type: Number,
            default: 0,
        },
        id:{
            type: String,
            default: ''
        }
    },
    data() {
        return {
            unitPriceValue:0,
            quickFees:{
                feeName:'',
                companyName:'',
                currency:'VND',
                exchangeRate:1,
                // unitPrice:0,
                tax:0,
                withTax:false,
            },
            companyNameList:[], // 往来单位列表
            feeNameList:[], // 费用名称列表
            DicList:[], // 币制列表
            boxTable:[],
            selectBox:[], // 选中的箱型箱号
            totalCost:0,// 选中费用合计
            rules:{
                companyName: [
                    { required: true, message: '请选择往来单位', trigger: 'change' }
                ],
                feeName: [
                    { required: true, message: '请选择费用名称', trigger: 'change' }
                ],
                currency: [
                    { required: true, message: '请选择币制', trigger: 'change' }
                ],
                exchangeRate: [
                    { required: true, message: '请输入汇率', trigger: 'change' },
                    { 
                        pattern: /^(?!0+(\.0+)?$)\d+(\.\d+)?$/,  // 匹配非零数字（支持小数） ^(?!0+(\.0+)?$)：逆向否定预查，排除纯 0（包括 0.0、0.00 等格式）
                        message: '汇率不能为0', 
                        trigger: ['blur', 'change']
                    }
                ],
                // unitPrice: [
                //     { required: true, message: '请输入单价', trigger: 'change' },
                //     { 
                //         pattern: /^(?!0+(\.0+)?$)\d+(\.\d+)?$/,  // 匹配非零数字（支持小数） ^(?!0+(\.0+)?$)：逆向否定预查，排除纯 0（包括 0.0、0.00 等格式）
                //         message: '单价不能为0', 
                //         trigger: ['blur', 'change']
                //     }
                // ],
                tax: [
                    { required: true, message: '请输入税率', trigger: 'change' }
                ]
            },
        }
    },
    watch: {
        quickFeesShow: {
            handler(newVal,oldVal) {
                    
                if(newVal){
                    this.getcompanyName()
                    this.getFeeName()
                    this.getTypeOption()
                    this.getBoxTable()
                }
            },
            deep: true, // 深度监听
            immediate: true // 立即执行
        }
    },
    methods: {
        // 失焦时格式化
        handleBlur() {
            this.unitPriceValue = this.formatNumber(Number(this.unitPriceValue));
        },
        // 聚焦时取消格式化
        handleFocus() {
            this.unitPriceValue = this.formatparseFloat(this.unitPriceValue.toString())
        },
        
        // 将字符串转为数字
        formatparseFloat(value) { 
            // 1. 移除所有逗号
            const cleanString = value.replace(/,/g, '');
            // 2. 将字符串转换为数字
            value = parseFloat(cleanString);
            // 3. 处理NaN情况
            if (isNaN(value)) {
                value = 0;
            }
            return value;
        },
        // 千分位格式化函数
        formatNumber(value) {
            return Number(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') // 1234567.89 → 1,234,567.89
        },
        // 表格失焦时格式化
        handleBlurTable(data){
            data.unitPrice =  this.formatNumber(data.unitPrice);
        },
        // 表格聚焦时取消格式化
        handleFocusTable(data) {
            data.unitPrice =   this.formatparseFloat(data.unitPrice.toString())
        },
        changeTotal(){
            this.totalCost = this.selectBox.reduce((acc, cur) => {
                return acc + this.truncateDecimals(this.formatparseFloat(cur.unitPrice.toString()))
            }, 0);
            this.totalCost = this.totalCost/100
        },
        // *100取整
        truncateDecimals(num) {
            let truncatedNum = Math.trunc(num * 100)
            // let truncatedNum = Math.trunc(num * 100) / 100;
            // 使用toFixed(2)来确保输出为两位小数的字符串格式
            truncatedNum = Number(truncatedNum.toFixed(2))
            return truncatedNum
        },
        // 查询费用名称 
        getFeeName() {
            let URL = `${url1.fee}/?feeName=`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.feeNameList = res.data.data
                }
            })
        },
        // 查询往来单位 
        getcompanyName() {
            let URL = `${url2.getList}/?name=`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.companyNameList = res.data.data
                }
            })
        },
        //获得币制数据
        getTypeOption() {
            let value = '币制';
            let URL = `${url1.getDicList}/?value=${value}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.DicList = res.data.data.data;
                }
            })
        },
        // 选择币制时修改汇率
        exitTaxRate(data){
            if(data === 'VND'){ 
                // 不可修改，为1
                this.quickFees.exchangeRate = 1
            }else{
                this.quickFees.exchangeRate = null
            }
        },  
        // 查询箱型箱量
        getBoxTable() {
            let URL = `${url1.getContainerList}/${this.id}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.boxTable = res.data.data.map(item => {
                        return{ ...item, unitPrice:0}
                    });
                }
            })
        },
        // 选中的表格
        handleSelectBox(val) {
            this.selectBox = val;
            // 合计金额
            this.totalCost = val.reduce((acc, cur) => {
                return acc + this.truncateDecimals(this.formatparseFloat(cur.unitPrice.toString()))
            }, 0)
            this.totalCost = this.totalCost/100
        },
        handleClose(){
            this.totalCost = 0
            this.$refs.quickFees.resetFields();
            this.unitPriceValue = 0
            this.quickFees = {
                feeName:'',
                companyName:'',
                currency:'VND',
                exchangeRate:1,
                // unitPrice:0,
                tax:0,
                withTax:false,
            },
            this.selectBox = []
            this.$emit('closeQuickFees', false);
        },
        // 费用填充
        priceFilling(){
            if(this.unitPriceValue && this.unitPriceValue > 0){
                this.boxTable = this.boxTable.map(item => { 
                    return { ...item, unitPrice: this.formatNumber(Number(this.unitPriceValue))}    
                })
            }else{
                // this.$message({
                //     type: 'error',
                //     message: '请正确输入单价'
                // });
            }
        },
        // 引入费用
        quickFeesSave(formName){ 
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // 判断是否选择箱型箱号
                    if(this.selectBox.length > 0){
                        let URL = `${url2.quickInsFee}/${this.id}/${this.quickFeesType}`;
                        const item = JSON.parse(JSON.stringify(this.quickFees));
                        item.tax = item.tax/100
                        item.containerList = this.selectBox.map(item=>{
                            if(item.unitPrice === '0' || item.unitPrice === ''){
                                return false
                            }else{
                                return {containerId:item.containerId, containerType:item.containerType, unitPrice: this.formatparseFloat(item.unitPrice.toString())}
                            }
                        })
                        for(let key in item.containerList){
                            //选中表格中单价为0
                            if(!item.containerList[key]){
                                this.$message.error('请正确输入单价');
                                return false
                            }
                        }
                        req.post(URL,item).then(res => {
                            if (res.data.code === 200) {
                                this.$emit('quickFeesValue', res.data.data);
                                // 不关闭弹窗，恢复值
                                this.unitPriceValue = 0
                                this.getBoxTable()
                                // this.handleClose()
                            }
                        })
                    }else{
                        this.$message.error('请选择箱号！');
                    }
                } else {
                    return false;
                }
            });
        },
    }
}

</script>
<style lang="css" scoped>
    ::v-deep .el-table{
        border: 1px solid #898989;
    }
    ::v-deep .el-table--border th.el-table__cell, .el-table__fixed-right-patch {
        border-bottom: 1px solid #898989;

    }
    /* ::v-deep .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf { */
        /* border-bottom: 1px solid #EBEEF5 !important; */
    /* } */
    ::v-deep .el-form-item{
        margin-bottom:18px !important;
    }
    ::v-deep .el-table--mini .el-table__cell {
        padding: 0px 0;
    }
</style>
